import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import ResponsiveTable from "../../components/ResponsiveTable";
import Modal from "../../components/Modal";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import moment from "moment"

export default function CustomerList() {
    const navigate = useNavigate();
    const [customersList, setCustomersList] = useState([])
    const [paymentList, setPaymentList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);
    const getCustomerData = () => {
        axios.get("/customers").then((res) => {
            setCustomersList(res.data);
        });
    }
    useEffect(() => {
        getCustomerData()
    }, []);
    const capitalizeFirstLetter = (word) => {
        if (!word || typeof word !== "string") return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
    };
    const getPaymentList = (customerId) => {
        axios.get(`/customers/${customerId}/payment-history`)
            .then(res => {
                console.log('Payment History:', res.data);
                setPaymentList(res.data?.payment_history?? [])
            })
            .catch(err => console.error(err));
    }
    const actions = [
        { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'View Payments', value: 'payment', icon: <CurrencyDollarIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "edit":
                navigate(`/customers/edit/${row.id}`);
                break;
            case "payment":
                getPaymentList(row.id)
                setIsModalOpen(true)
                break;
            case "delete":
                if (window.confirm("Are you sure you want to delete this Customer?")) {
                    axios.delete(`/customers/${row.id}`).then(() => {
                        getCustomerData()
                    });
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/purchases/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
        {
            header: "Created Date", accessor: "expense_date",
            render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
        },
        { header: "Customer Name", accessor: "name" },
        { header: "Email", accessor: "email" },
        { header: "Phone", accessor: "phone" },
        { header: "Address", accessor: "address" },
        {
            header: "Total Paid Amt", accessor: "total_paid",
            render: (value, row) => <span className="flex justify-end text-green-800 font-medium ">{value} BDT</span>
        },
        {
            header: "Sale Due Amt", accessor: "sales_due",
            render: (value, row) => <span className="flex justify-end text-red-600 font-medium">{value} BDT</span>
        },
    ];

    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <div className="w-full">
                <ExportButtons title="Customers List" onDownload={handleDownload} />
                <ResponsiveTable
                    columns={columns}
                    data={customersList}
                    showActions
                    actionButtons={actions}
                    onActionClick={handleActionClick}
                />
            </div>
            {/* Modal */}
            <Modal
                isOpen={isModalOpen}
                onClose={closeModal}
                header={<span className="text-blue-600">Payment History</span>}
                body={
                    <div className="mb-3">
                        <table className="w-full my-2 border text-xs">
                            <thead className="bg-blue-800 text-white">
                                <tr>
                                    <th className="border px-2 py-1">#</th>
                                    <th className="border px-2 py-1">Date</th>
                                    <th className="border px-2 py-1">Bank Name</th>
                                    <th className="border px-2 py-1">Description</th>
                                    <th className="border px-2 py-1">Amount</th>
                                    <th className="border px-2 py-1">Type</th>
                                </tr>
                            </thead>
                            {paymentList.length > 0 ? paymentList.map((item, i) => (
                                <tr className='odd:bg-white even:bg-gray-100' key={i}>
                                    <td className="border px-2 py-1 font-medium">{i + 1}</td>
                                    <td className="border px-2 py-1 text-center">{moment(item.created_at).format("DD-MM-YYYY hh:mm:ss A")}</td>
                                    <td className="border px-2 py-1 text-center">{item.bank_name}</td>
                                    <td className="border px-2 py-1 text-center">{item.description}</td>
                                    <td className="border px-2 py-1 text-center font-semibold">{Number(item.amount).toFixed(2)}</td>
                                    <td className="border px-2 py-1 text-center">{capitalizeFirstLetter(item.type)}</td>
                                </tr>
                            )) : <tr className="mb-2">
                                <td colSpan={5} className="text-center py-2">No payment found</td>
                            </tr>}
                        </table>
                    </div>
                }
                footer={
                    <div className="flex gap-2">
                        <button
                            onClick={closeModal}
                            className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                        >
                            Close
                        </button>
                    </div>
                }
            />
        </div>
    );
}